import React, { useEffect, useState } from "react";
import '../../../CSS/Areas.css'
import {BsPlus} from "react-icons/bs";
import { useNavigate } from "react-router";
import { getPermission} from "../../../Conexiones/Conexion";
import { Button, CloseButton, Modal } from 'react-bootstrap';
import { FaArrowLeftLong } from "react-icons/fa6";
import { deleteApi, getApi, postApi, putApi } from "../../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningModal, warningToast } from "../../../Utils/AlertMessage";
import Loading from '../../../Utils/Loading';

function Areas(){
    const [areas, setAreas] = useState([]);
    const [tablaAreas, setTablaAreas] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const navigate = useNavigate();
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'areas/';
    const [isLoading,setIsLoading]=useState(false);

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [nombreAdd, setNombreAdd] = useState();
    const [isSaving, setSaving] = useState(false);
     //EDITAR
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const [editNombre,setEditNombre] = useState ()
    const [idArea,setArea] = useState ()
    const handleShowEdit = (id,nombre) =>{
        setShowEdit(true);
        setEditNombre(nombre);
        setArea(id);
    } 
    const getAreas = async () =>{
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setAreas(res.data)
                setTablaAreas(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };

    useEffect (()=>{
        const getAreas = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,11);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setAreas(res.data);
                        setTablaAreas(res.data);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        };
        getAreas();
    },[idUsuario,navigate]);
    
    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value);
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaAreas.filter((elemento)=> {
            if  (elemento.nombreArea.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento;
            }
            return resBusqueda;
        })
        setAreas(resBusqueda);
    }

    const regresar = () => {
        navigate('/inicio/Catalogos');
    }

    //ELIMINAR AREA
    const modalDelete = (id) => {
        warningModal('¿QUIERES ELIMINAR ESTA AREA?')
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="¡Registro eliminado correctamente!"){
                        getAreas();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    //AGREGAR AREA
    const store = async (e) =>{
        e.preventDefault()
        setSaving(true);
        if(nombreAdd.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri;
            const data = {nombreArea:nombreAdd}
            const res = await postApi(endpoint,data)
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleClose();
                    getAreas();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }

    //EDITAR AREA
    const update = async (e) =>{
        e.preventDefault()
        if(editNombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri + idArea;
            const data = {nombreArea:editNombre};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro actualizado correctamente!"){
                    handleCloseEdit();
                    getAreas();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
    }    
   
    return(
        <div className="areas">
            {
                isLoading ?
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label>GESTIÓN DE AREAS</label>
                    </div>
                    <div className='divbotonA' >                                                                                             
                        <div className='botonA' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor"  onClick={handleShow} type="button">
                                <label className="agregar">AREA</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>                    
                        </div>
                    </div>
                    {
                        areas.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA" >
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered text-uppercase">
                                        <thead className="encabezado">
                                            <tr >                                
                                                <th>AREA</th>
                                                <th style={{width:'50%'}}>ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {areas.map(area =>{
                                                return(                                    
                                                    <tr key={area.idArea}>                                       
                                                        <td valign="middle">{area.nombreArea}</td>                                    
                                                        <td>
                                                            <div>
                                                                <div className="btn iconoH" onClick={() => handleShowEdit(area.idArea,area.nombreArea)} style={{margin:'5px'}}>
                                                                    <span className="bi bi-pen" title="EDITAR"></span>
                                                                </div>
                                                                <div className="btn iconoH" style={{margin:'5px'}} onClick={() => modalDelete(area.idArea)}>
                                                                    <span className="bi bi-trash" title="ELIMINAR"></span>
                                                                </div>                                     
                                                            </div>
                                                        </td>                                                                                                
                                                    </tr>                                                                        
                                                )
                                            })}                        
                                        </tbody>
                                    </table>
                                </div>      
                            </div>
                        )
                    }

                    {/*AGREGAR AREA*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-area">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR AREA</Modal.Title>
                            <CloseButton onClick={handleClose} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombreAdd(e.target.value) } />
                                </div>  
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleClose}>CANCELAR</Button>
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>  

                    {/*EDITAR AREA*/}
                    <Modal show={showEdit} onHide={handleCloseEdit} id="modal-editar-area">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR AREA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setEditNombre(e.target.value)} defaultValue={editNombre}/>
                                </div>  
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default Areas;